import { FilesApi } from "api/FilesApi";
import { FileUpload, FileUploadHandlerEvent, FileUploadSelectEvent } from "primereact/fileupload";
import { ProgressBar } from "primereact/progressbar";
import React, { forwardRef, useCallback, useImperativeHandle, useRef, useState } from "react";
import { easasAlert } from "../../fragments/easas-global-fragment/EasasGlobalAlerts";

export type FileUploaderRef = {
  upload: () => void;
};

interface FileUploadParams {
  isEdit: boolean;
  id?: string;
  fileName?: string;
  desc?: string;
  fileTags?: string[];
  isPublic: boolean;
  onSelected?: (file: File) => void;
  onUploaded?: () => void;
  onErrored?: () => void;
}

export const FileUploader = forwardRef<FileUploaderRef, FileUploadParams>(function FileUploader(props, ref) {
  const fileUpRef = useRef<FileUpload>(null);

  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  useImperativeHandle(ref, () => ({
    upload() {
      upload();
    },
  }));

  const upload = () => {
    fileUpRef.current!!.upload();
  };

  const onSelected = (event: FileUploadSelectEvent) => {
    if (props.onSelected) {
      props.onSelected(event.files[0]);
    }
  };

  const onUploaded = () => {
    if (props.onUploaded) {
      props.onUploaded();
    }
  };

  const onErrored = () => {
    if (props.onErrored) {
      props.onErrored();
    }
  };

  const uploadHandler = (event: FileUploadHandlerEvent) => {
    console.log("uploadHandler", event);
    if (event.files.length === 0 && !props.isEdit) {
      easasAlert({ summary: "No files selected", severity: "warn" });
      onErrored();
      return;
    }

    setIsUploading(true);

    const req = {
      isPublic: props.isPublic,
      id: props.id,
      file: event.files[0],
      fileName: props.fileName,
      desc: props.desc,
      tags: props.fileTags,
      progressCallback: onProgress,
    };

    FilesApi.uploadFileGeneral(req).then(r => {
      setIsUploading(false);

      if (!r.error) {
        easasAlert("File uploaded");
        onUploaded();
        fileUpRef.current!!.clear();
      } else {
        easasAlert({ summary: "Error uploading file", severity: "error" });
        onErrored();
      }
    });
  };

  const onProgress = useCallback((event: number) => {
    setUploadProgress(event);
    console.log("onProgress", uploadProgress);
  }, []);

  return (
    <>
      <FileUpload
        ref={fileUpRef}
        mode="basic"
        customUpload
        onSelect={onSelected}
        uploadHandler={uploadHandler}
        disabled={isUploading}
      />

      {isUploading && (
        <div>
          Uploading...
          <ProgressBar value={uploadProgress} />
        </div>
      )}
    </>
  );
});
